import { MobizOrganizationRole } from '../../core';
import { CustomerIdentityField } from '../other/customer-identity-field.type';
import { ModuleSettings } from './module-settings.do';


/**
 * Module settings ValueSchema: SalesModuleSettings v1.
 */
export class SalesModuleSettings extends ModuleSettings {

  /**
   * Flag to enable/disable Customer Alias field.
   */
  public CustomerShowAlias: boolean;

  /**
   * Which field/fields should act as Customer Identity fields.
   */
  public CustomerIdentityField: CustomerIdentityField;

  /**
   * Flag to enable/disable Customer AddressLine2 field.
   */
  public CustomerShowAddressLine2: boolean;

  /**
   * Flag to enable/disable Customer AddressLine3 field.
   */
  public CustomerShowAddressLine3: boolean;

  /**
   * Flag to enable/disable Customer AddressLine4 field.
   */
  public CustomerShowAddressLine4: boolean;

  /**
   * Flag to enable/disable Customer Zip field.
   */
  public CustomerShowZip: boolean;

  /**
   * Flag to enable/disable Customer Country field.
   */
  public CustomerShowCountry: boolean;

  /**
   * Flag to enable/disable Salesperson features.
   */
  public EnableSalesPerson: boolean;

  /**
   * Flag to enable/disable Unit Prices with VAT. If disable, Unit Prices are used without VAT.
   */
  public UnitPriceWithVAT: boolean;

  /**
   * Flag to enable/disable Netto Prices on Invoices. If disabled, Brutto Prices will be used.
   */
  public InvoiceCalculateNetPricePrLine: boolean;

  /**
   *  The default html invoice/quote/order template.
   */
  public PdfTemplateSalesHead: string;

  /**
   * Flag to enable/disable Item Search Number (AliasItemCode) field.
   */
  public ItemShowAliasItemCode: boolean;

  /**
   * Setting that stores how many Price Categories are in use.
   */
  public NumberOfPriceCategories: number;

  /**
   * Which role can change Invoice Due Date in UI.
   */
  public WhoCanChangeInvoiceDueDate: MobizOrganizationRole;

  /**
   * Which role change Invoice Line Unit Price in UI.
   */
  public WhoCanChangeInvoiceLineUnitPrice: MobizOrganizationRole;

  /**
   * String that separates groups of digits to the left of the decimal in numeric values.
   */
  public NumberGroupSeparator: string;

  /**
   * String to use as the decimal separator in numeric values.
   */
  public NumberDecimalSeparator: string;

  /**
   * Flag to enable/disable orders.
   */
  public OrdersEnabled: boolean;

  /**
   * Flag to enable/disable quotes.
   */
  public QuotesEnabled: boolean;

  /**
   * Flag to show/hide the ItemReceiver field on Invoice/Quote/Order
   */
  public EnableItemReceiver: boolean;

  /**
   * Flag to enable/disable the feature of adding Items to Invoice/Quote/Order by scanning a Bar Code.
   */
  public EnableItemBarCode: boolean;

  /**
   * Flag to enable/disable Payment features.
   */
  public EnablePayments: boolean;

  /**
   * Flag to enable/disable features special prices and discounts.
   */
  public EnableSpecialPriceDiscount: boolean;

  /**
   * Flag to enable/disable warehouse support.
   */
  public EnableWarehouses: boolean;

  /**
   * Flag to enable/disable items being sold in units.
   */
  public EnableItemUnits: boolean;

  /**
   * Source of the logo image for rendered sales PDF files.
   */
  public LogoSrc: string;
}
